import { productCart } from '../../types';

interface InitialState {
  products: Array<productCart>;
  productsTotalPrice: number;
  totalProducts: number;
  totalQuantity: number;
}

const UpdateCartAction = 'Cart';

export default InitialState;
export { UpdateCartAction };
